module.exports = __webpack_public_path__ + "img/sintesis.b39f131c.svg";